import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@guildeducationinc/recess';
import { useCurrentClientConfig } from '@src/hooks/useCurrentClientConfig';
import { useAuth } from '@src/hooks/useAuth';
import { useUserLocale } from '@src/hooks/useUserLocale';
import { useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
export const LocaleSelect = () => {
    const { t } = useLocale();
    const { currentUser } = useAuth();
    const { locale, setLocale, clientLocales } = useUserLocale(!currentUser);
    const { clientConfig } = useCurrentClientConfig();
    const handleChange = (e) => {
        const lang = e.target.value ?? undefined;
        try {
            setLocale(lang);
        }
        catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            console.error(e.message);
        }
    };
    const localeOptions = useMemo(() => (clientLocales || []).map(l => ({
        value: l.identifier,
        label: l.displayName,
    })), [clientLocales]);
    // Only show language selector if there are multiple locales available
    if (!clientConfig || (clientLocales || []).length <= 1)
        return null;
    return (_jsx(Select, { label: t('Language'), value: locale, onChange: handleChange, options: localeOptions, isClearable: false }));
};
